import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";

const LABELS = {
  "your-route": "Your Route",
  "residency-documents": "Residency & Documents",
  "fmm-land-entry": "FMM / Land Entry",
  "driving": "Driving to Mexico",
  "drivers-transport": "Drivers & Transport",
  "pets": "Moving with Pets",
  "cities-housing": "Cities & Housing",
  "mexico-city": "Mexico City",
  "guadalajara": "Guadalajara",
  "queretaro": "Querétaro",
  "puerto-vallarta": "Puerto Vallarta",
  "san-miguel-de-allende": "San Miguel de Allende",
  "oaxaca-city": "Oaxaca City",
  "monterrey": "Monterrey",
  "cost-planning": "Cost & Pricing",
  "arrival-settling": "Arrival & Settling In",
  "safety-travel-planning": "Safety & Travel Planning",
  "how-we-help": "How We Help",
  "merida": "Mérida (home base)",
  "explore-mexico": "Explore Mexico",
  "cost-calculator": "Cost Calculator",
};

const RELATED = {
  "your-route": ["residency-documents", "driving", "cost-planning"],
  "residency-documents": ["fmm-land-entry", "your-route", "how-we-help"],
  "fmm-land-entry": ["driving", "residency-documents", "safety-travel-planning"],
  "driving": ["fmm-land-entry", "drivers-transport", "safety-travel-planning"],
  "drivers-transport": ["driving", "cost-planning", "your-route"],
  "pets": ["driving", "arrival-settling", "merida"],
  "cities-housing": ["merida", "mexico-city", "arrival-settling"],
  "mexico-city": ["merida", "cities-housing", "cost-planning"],
  "guadalajara": ["merida", "cities-housing", "explore-mexico"],
  "queretaro": ["merida", "cities-housing", "explore-mexico"],
  "puerto-vallarta": ["merida", "cities-housing", "explore-mexico"],
  "san-miguel-de-allende": ["merida", "cities-housing", "explore-mexico"],
  "oaxaca-city": ["merida", "cities-housing", "explore-mexico"],
  "monterrey": ["merida", "cities-housing", "explore-mexico"],
  "cost-planning": ["cost-calculator", "your-route", "how-we-help"],
  "arrival-settling": ["cities-housing", "merida", "how-we-help"],
  "safety-travel-planning": ["driving", "fmm-land-entry", "your-route"],
  "how-we-help": ["your-route", "cost-planning", "merida"],
  "merida": ["cities-housing", "cost-planning", "how-we-help"],
};

const DEFAULT = ["merida", "your-route", "how-we-help"];

export default function RelatedGuides({ slug }) {
  const items = (RELATED[slug] || DEFAULT).filter((s) => s !== slug).slice(0, 3);
  if (!items.length) return null;
  return (
    <section className="mx-auto max-w-7xl px-6 lg:px-12 pb-12" data-testid="related-guides">
      <h2 className="text-xl font-medium text-charcoal-800 mb-5">Related guides</h2>
      <div className="grid gap-4 sm:grid-cols-3">
        {items.map((s) => (
          <Link
            key={s}
            to={`/${s}`}
            data-testid={`related-link-${s}`}
            className="group flex items-center justify-between rounded-2xl border border-sand-300 bg-white px-5 py-4 transition-all hover:border-terracotta hover:shadow-[0_6px_24px_rgba(42,38,36,0.08)]"
          >
            <span className="font-medium text-charcoal-800">{LABELS[s] || s}</span>
            <ArrowRight size={16} className="text-terracotta transition-transform group-hover:translate-x-1" />
          </Link>
        ))}
      </div>
    </section>
  );
}
